export default __webpack_public_path__ + "audio-classification524168.png";